module.exports = "/_next/static/images/slide3-2x-a0e1fb6c81946ac06402fd1d749f43b4.jpg.webp";